export class AlterarSenha {
  idUsuario?: number;
  senhaAtual?: string;
  novaSenha?: string;
  confirmarSenha?: string;
}
